export default (mask, value) => {
  const masks = {
    phone: value.replace(' ', '').replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4'),
    zipCode: value.replace(/(\d{5})(\d{3})/, '$1-$2'),
  };
  return masks[mask];
};
